import React from "react";
import StatusGuestsListComponent from "../StatusGuestsListComponent/StatusGuestsListComponent";

const LiquorComponent = () => {
  return (
    <div className="add-all-guests-container">
      <div className="notparticipatingGuestsPage">
        <StatusGuestsListComponent
          liquorOnly
          liquorValue="Yes"
          statusFilter="Participation Confirmed"   // ✅ ADD THIS
          hideFamily
          hideStatus
          backTo="/dashboard"
          showMobileWhatsApp={false}
        />
      </div>
    </div>
  );
};

export default LiquorComponent;